import Icon from "@ant-design/icons"
import React from "react"

const tier1Icon = () => (
    <svg width="30" height="26" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M27.5 4.25H21.25V3C21.25 1.62122 20.1288 0.5 18.75 0.5H11.25C9.87122 0.5 8.75 1.62122 8.75 3V4.25H2.5C1.12122 4.25 0 5.37122 0 6.75V10.5C0 11.8788 1.12122 13 2.5 13H12.5V12.375C12.5 12.0295 12.7795 11.75 13.125 11.75H16.875C17.2205 11.75 17.5 12.0295 17.5 12.375V13H27.5C28.8788 13 30 11.8788 30 10.5V6.75C30 5.37122 28.8788 4.25 27.5 4.25ZM11.25 4.25V3H18.75V4.25H11.25Z"
            fill="#60CDB2"
            fill-opacity="0.5"
        />
        <path
            d="M29.6533 13.6754C29.4403 13.5698 29.1858 13.5942 28.9978 13.737C28.5535 14.0733 28.0359 14.2509 27.5 14.2509H17.5V16.1259C17.5 16.4714 17.2205 16.7509 16.875 16.7509H13.125C12.7795 16.7509 12.5 16.4714 12.5 16.1259V14.2509H2.5C1.96411 14.2509 1.44653 14.0733 1.0022 13.737C0.813599 13.593 0.559692 13.5686 0.34668 13.6754C0.134277 13.781 0 13.9976 0 14.2351V23.0009C0 24.3797 1.12122 25.5009 2.5 25.5009H27.5C28.8788 25.5009 30 24.3797 30 23.0009V14.2351C30 13.9976 29.8657 13.781 29.6533 13.6754Z"
            fill="#60CDB2"
        />
    </svg>
)

const Tier1Icon = (props: any) => <Icon component={tier1Icon} {...props} />

export default Tier1Icon
